module.exports = __webpack_public_path__ + "img/photo_2023-06-04 10.54.47.9761eb7e.jpeg";